<template>
  <div class="ModalConfirmDelete">
    <div id="deleteModal" class="modal">
      <div class="modal-content">
        <div class="row">
          <div class="col s4">
            <img src="/img/delete.svg" class="responsive-img" alt="">
          </div>
          <div class="col s8">
            <h5>Confirme a exclusão da simulação</h5>
            <p>Essa operação é irreversível, depois de excluída permanentemente a simulação não poderá ser recuperada</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#!"
          class="modal-close waves-effect waves-green btn-flat"
          @click="confirmDelete(false)"
        >Manter Simulação</a>

        <a href="#!" class="modal-close waves-effect btn red darken-4" @click="confirmDelete(true)">
          <i class="material-icons left">delete</i> Confirmar
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalConfirmDelete",
  methods: {
    confirmDelete: function(booleanOption) {
      this.$emit("confirmDelete", {
        delete: booleanOption
      });
    }
  }
};
</script>